// extracted by mini-css-extract-plugin
module.exports = {"add-supplier-wrapper":"AddSupplier_add-supplier-wrapper__2kuaz","input1":"AddSupplier_input1__b4c1-","close":"AddSupplier_close__3Xh6N","add":"AddSupplier_add__1jrmD"};